<template>
  <v-app>
    <v-main class="d-flex justify-center align-center">
      <v-container class="py-0">
        <v-row class="fill-height d-flex justify-content-center">
          <v-col cols="12" md="6" class="d-flex flex-column justify-content-center fill-height mx-0 px-0">
            <v-row class="d-flex justify-content-center justify-content-lg-start">
              <!-- Logo -->
              <router-link :to="{
                path: '/',
              }" title="TicketShop" tag="a"><v-img max-height="64" max-width="85" src="/images/Logo-black.svg"></v-img>
              </router-link>
            </v-row>
            <v-row>
              <v-card-title class="mx-auto display-1 font-weight-black" tag="h4">
                Registrarme
              </v-card-title>
              <v-text class="mx-auto mb-6 text-center d-flex align-items-center flex-nowrap" max-width="360">
                <v-card-text class="m-0 p-0 text-sm-rigth text-body-2 text-no-wrap">¿Ya tienes una cuenta en Tiket Shop?
                </v-card-text><router-link :to="{
                  path: '/login',
                }">
                  <a class="pa-4 primary--text text-subtitle-2 text-no-wrap" href="#" text-color="primary">
                    Iniciar sesión
                  </a>
                </router-link>
              </v-text>
            </v-row>

            <v-row>
              <!--  -->
              <!-- Formulario -->
              <v-col cols="12" class="mx-0 px-0 mx-md-2 px-md-2">
                <v-stepper v-model="e6" vertical>
                  <v-stepper-step :complete="e6 > 1" step="1">
                    Formulario de Registro
                    <small>Todos los campos son requeridos</small>
                  </v-stepper-step>
                  <v-stepper-content :complete="e6 > 1" step="1">
                    <form @submit.prevent="doRegister" autocomplete="off" md="12">
                      <v-card-title class="mx-0 px-0">Datos Personales</v-card-title>
                      <!--Nombre -->
                      <v-text-field class="pb-n5" cols="12" label="Nombres  " outlined required
                        v-model="user.nombre"></v-text-field>
                      <!-- Apellido -->
                      <v-text-field class="pb-n5" label="Apellidos  " outlined v-model="user.apellidos"></v-text-field>
                      <!-- Identificación-->
                      <v-row class="d-flex flex-row flex-no-wrap">
                        <v-col xs="3" cols="4" class="p-0 pb-n5">
                          <v-select v-model="user.tipo_identificacion" item-value="id" item-text="code"
                            :items="tipoIdentificaciones" label="Tipo de identificación  " outlined required></v-select>
                        </v-col>
                        <!-- Número de Identificación --><!-- :item="numeroIdentificación" -->
                        <v-spacer></v-spacer>
                        <v-col cols="8" class="p-0 pl-2 ml-n2 pb-n5">
                          <v-text-field label="Número de identificación  " type="number" item-value="id"
                            item-text="code" outlined required v-model="user.identificacion"
                            @blur="validarNumeroId"></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Correo -->
                      <v-text-field class="pb-n5" label="Correo electrónico  " type="email" outlined required
                        v-model="user.email" :rules="emailRules" @blur="validarCorreo"></v-text-field>

                      <!-- Departamento-->
                      <v-card-title class="mx-0 px-0">Dirección y teléfono</v-card-title>
                      <v-select class="pb-n5" v-model="user.departamento" item-value="id" item-text="descripcion"
                        :items="departamentos" label="Departamento  " outlined persistent-hint required></v-select>
                      <!-- Ciudad -->
                      <v-select class="pb-n5" v-model="user.ciudad" item-value="id" item-text="descripcion"
                        :items="ciudadesSelect" label="Ciudad  " outlined persistent-hint required
                        :disabled="user.departamento == null"></v-select>
                      <!-- Dirección -->
                      <v-text-field class="pb-n5" label="Dirección  " type="text" outlined minlength="8"
                        v-model="user.direccion" required></v-text-field>
                      <!-- Telefono -->
                      <v-text-field class="pb-n5" label="Celular  " type="number" outlined v-model="user.telefono"
                        min="0" minlength="10" autocomplete="nope" @blur="validarTelefono" required></v-text-field>

                      <!-- Constraseña -->
                      <v-card-title class="px-0 mx-0">Contraseña </v-card-title>
                      <v-text-field v-model="user.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'" class="pb-n5" label="Contraseña  " outlined
                        @click:append="show1 = !show1" required autocomplete="new-password" :rules="passwordRules">
                      </v-text-field>
                      <!-- Confirmar Constraseña -->
                      <v-text-field v-model="user.c_password" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show2 ? 'text' : 'password'" class="pb-n5" label="Confirmar contraseña" outlined
                        @click:append="show2 = !show2" required autocomplete="new-password"
                        :rules="[passwordMatchRule]">
                      </v-text-field>

                      <!-- Botones de Acciones -->
                      <v-row> </v-row>
                    </form>
                    <v-col cols="12" text-color="primary" class="text-center">
                      <v-btn color="primary" block rounded @click="e6 = 2" :disabled="checkBtn">
                        Continuar
                      </v-btn>
                    </v-col>
                    <v-col cols="12" text-color="primary" class="text-center">
                      <router-link :to="{ path: '/' }">
                        <v-btn color="outline" outlined block rounded>Cancelar</v-btn>
                      </router-link>
                    </v-col>
                  </v-stepper-content>
                  <v-stepper-step :complete="e6 > 2" step="2">
                    Validar Correo
                  </v-stepper-step>
                  <v-stepper-content step="2">
                    <v-card rounded class="text-center rounded-xl py-4" flat>
                      <v-btn icon class="surfaceContainerHighest">
                        <v-icon color="primary">mdi-email-outline</v-icon>
                      </v-btn>
                      <div class="text-center pt-4" style="font-family: Cabin">
                        <v-text>
                          <h4>Por favor revisa tu correo</h4>
                          <h6 class="font-weight-regular">
                            Nosotros enviamos un código a
                            <b>{{ user.email }}</b>
                          </h6>
                        </v-text>
                      </div>
                      <div class="mx-1 p-1" id="validarcodigo">
                        <row row-height="80" class="row">
                          <v-otp-input v-model="otp" :disabled="loading" length="4" @finish="onFinish">
                          </v-otp-input>
                          <v-overlay absolute :value="loading">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-overlay>
                        </row>
                      </div>
                      <v-text class="d-flex align-content-center">
                        <v-card-text class="py-0 align-self-center">¿No te llegó el código?</v-card-text>
                        <v-btn class="font-weight-bold py-0" text color="primary" style="box-sizing: border-box"
                          @click="reenviarCorreo">Reenviar Código</v-btn>
                      </v-text>
                      <v-card-actions class="text-center flex-column">
                        <v-col class="p-0 mb-0" cols="12">
                          <v-btn class="mb-2 font-weight-medium" height="44px" rounded block color="primary"
                            @click="validarCodigo">Validar Código</v-btn>
                        </v-col>
                        <v-col class="p-0 mt-0" cols="12">
                          <v-btn color="outline" outlined height="44px" block rounded @click="e6 = 1">Regresar al
                            Formulario</v-btn>
                        </v-col>
                      </v-card-actions>
                    </v-card>
                  </v-stepper-content>
                  <v-stepper-step :complete="e6 > 3" step="3">
                    Finalizar Registro
                  </v-stepper-step>
                  <v-stepper-content step="3">
                    <v-col cols="12" class="text-center">
                      <v-btn color="primary" block rounded :disabled="e6 < 3" @click="terminarRegistro()">Finalizar
                        Registro</v-btn>
                    </v-col>
                  </v-stepper-content>
                </v-stepper>
              </v-col>
            </v-row>

            <!-- TicketShop y Ayuda -->
            <v-row class="d-flex row--dense ">
              <v-col cols="12" class="text-center">
                <v-btn text disabled>
                  © TicketShop
                  {{ new Date().getFullYear() }}
                  Colombia.
                </v-btn>
              </v-col>
              <v-col cols="12" class="text-center">

                <v-btn text color="primary" href="mailto:contacto@ticketshop.com.co">

                  <v-icon left> mail </v-icon>
                  contacto@ticketshop.com.co

                </v-btn>

              </v-col>
            </v-row>
          </v-col>

          <!-- Imagen lateral -->
          <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="6">
            <v-img class="fill-height m-0" cover src="/images/login/LOGIN.webp">
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import axios from 'axios';
import { configApi } from '../api/configApi';
export default {
  async beforeCreate() {
    await this.$store.dispatch('user/listTipoIdentificaciones');
    await this.$store.dispatch('departamento/listDepartamentos');
    await this.$store.dispatch('ciudad/listCiudades');
  },
  created() {
    this.user.nombre = null;
    this.user.apellidos = null;
    this.user.email = null;
    this.user.password = null;
    this.user.c_password = null;
    this.user.identificacion = null;
    this.user.direccion = null;
    this.user.ciudad = null;
    this.user.departamento = null;
    this.user.telefono = null;
    this.user.activarmodalvalidacion = false;
  },
  data() {
    return {
      otp: '',
      loading: false,
      passwordvalido: false,
      e6: 1,
      show1: false,
      show2: false,
      dialog: false,
      disabled: false,
      finalizarRegistro: false,
      continuarRegistro: false,
      telefonodisabled: false,
      activeBoton: true,
      sum: 0,
      userLogin: {
        email: null,
        password: null,
      },
      user: {
        nombre: null,
        apellidos: null,
        email: null,
        password: null,
        c_password: null,
        identificacion: null,
        tipo_identificacion: 1,
        direccion: null,
        ciudad: null,
        departamento: null,
        telefono: null,
        id_rol: 2,
        codigoverificacion: '',
        activarmodalvalidacion: false,
        codigoenviado: '',
      },
      fieldValues: ['', '', '', ''],
      emailRules: [
        (v) =>
          /.+@.+/.test(v) || 'Direccion de correo electrónico incorrecta',
      ],
      passwordRules: [
        (value) => !!value || 'La contraseña es requerida.',
        (value) =>
          value.length >= 8 ||
          'La contraseña debe tener al menos 8 caracteres.',
        (value) =>
          /[A-Z]/.test(value) ||
          'La contraseña debe contener al menos una letra mayúscula.',
        (value) =>
          /[0-9]/.test(value) ||
          'La contraseña debe contener al menos un número.',
        (value) =>
          /[!@#$%^&*(),.?":{}|<>_-]/.test(value) ||
          'La contraseña debe contener al menos un carácter especial.',
      ],
      requiredRule: [(v) => !!v || 'Este campo es requerido'],
    };
  },
  watch: {},
  methods: {
    async validarTelefono(event) {
      const numtelefono = this.user.telefono;
      if (numtelefono.length < 10) {
        swal('El Número de teléfono debe tener 10 digitos', '', 'warning');
        this.telefonodisabled = false;
      } else {
        this.telefonodisabled = true;
      }
    },
    checkKey(opcion, event) {
      const valueToPreserve = event.key;
      const keyCode = event.keyCode || event.which;
      event.preventDefault();
      if (
        (keyCode >= 96 && keyCode <= 105) ||
        (keyCode >= 48 && keyCode <= 57)
      ) {
        this.fieldValues[opcion - 1] = valueToPreserve;
        if (opcion < 5) {
          this.$refs['field' + opcion].focus();
        }
      } else {
        this.fieldValues[opcion - 1] = '';
      }
    },
    async onFinish() {
      this.loading = true;
      await this.validarCodigo();
      this.loading = false;
    },
    async validarCodigo() {
      if (this.otp.length > 1) {
        if (this.user.codigoenviado == this.otp) {

          this.user.codigoverificacion = '';
          this.otp = ''; // Limpiar el campo OTP
          swal('Correo Verificado Exitosamente', '', 'success').then(() => {
            this.e6 = 3;
          });
        } else {
          swal(
            'Error',
            'Debes ingresar un código corrrecto - si no te llego el código, rectifica el correo si esta bien escrito',
            'error'
          );
        }
      } else {
        swal('Error', 'Debes ingresar un código corrrecto ', 'error');
      }
    },
    async validarCorreo(event) {
      const correo = this.user.email;
      this.user.activarmodalvalidacion = false;
      if (correo.length > 1) {
        axios
          .post(`${configApi.apiUrl}enviar_codigo_confirmacion`, this.user)
          .then((res) => {
            if (res.status == 200) {
              this.user.activarmodalvalidacion = true;
              this.user.codigoenviado = res.data.success.codigo_confirmacion;
            } else {
              this.user.email = null
              swal('Correo Electrónico Duplicado', res.data.error, 'warning')
            }
          });
      } else {
        swal('Campo Vacío', 'Debe ingresar un correo válido', 'warning');
      }
    },
    async reenviarCorreo(event) {
      swal(
        'El nuevo código se ha enviado al correo indicado ',
        'si no encuentras el correo en la bandeja de entrada, verifica el spam o correo no deseados',
        'success'
      );
      const correo = this.user.email;
      //this.user.activarmodalvalidacion = false;
      if (correo.length > 1) {
        axios
          .post(`${configApi.apiUrl}enviar_codigo_confirmacion2`, this.user)
          .then((res) => {
            if (res.status == 200) {
              //this.user.activarmodalvalidacion = true;
              this.user.codigoenviado = res.data.success.codigo_confirmacion;
            } else {
              swal(
                'Error al enviar el correo, por favor verificarlo',
                res.data.error,
                'warning'
              );
            }
          });
      } else {
        swal('Campo Vacío', 'Debe ingresar un correo válido', 'warning');
      }
    },
    async terminarRegistro() {
      this.doRegister()
    },
    async validarNumeroId(event) {
      const documento = this.user.identificacion;
      this.user.activarmodalvalidacion = false;
      if (documento.length > 1) {
        axios
          .post(`${configApi.apiUrl}validar_documento_usuario`, this.user)
          .then((res) => {
            if (res.status == 200) {
              return;
            } else {
              swal(
                'Número de Identificación Duplicado',
                res.data.error,
                'warning'
              );
            }
          });
      } else {
        swal(
          'Campo Vacío',
          'Debe ingresar un número de identificación',
          'warning'
        );
      }
    },
    doRegister() {
      if (
        this.user.nombre != null &&
        this.user.apellidos != null &&
        this.user.tipo_identificacion != null &&
        this.user.identificacion != null &&
        this.user.email != null &&
        this.user.direccion != null &&
        this.user.departamento != null &&
        this.user.ciudad != null
      ) {
        if (this.user.password == this.user.c_password) {
          this.userLogin.email = this.user.email;
          this.userLogin.password = this.user.password;

          if (this.$store.dispatch('doRegister', this.user)) {
            setTimeout(() => {
              this.$store.dispatch('doLogin', this.userLogin);
            }, '3000');
          }
        } else {
          swal('Error!', 'Las contraseñas deben ser iguales!', 'error');
        }
      } else {
        swal(
          'Error!',
          'Debe completar todos los campos obligatorios!',
          'error'
        );
      }
    },
    showFormLogin() {
      this.$store.state.modalRegister = false;
      this.$store.state.modalLogin = true;
    },
    closeModalRegisterAndLogin() {
      this.$store.state.modalRegister = false;
      this.$store.state.modalLogin = false;
    },
  },
  computed: {
    tipoIdentificaciones() {
      return this.$store.getters['user/listTipoIdentificaciones'];
    },
    descripcionTipoIdentificacion() {
      return this.tipoIdentificaciones.filter(
        (item) => item.id === this.user.tipo_identificacion
      )[0]
        ? this.tipoIdentificaciones.filter(
          (item) => item.id === this.user.tipo_identificacion
        )[0].descripcion
        : '';
    },
    ciudades() {
      return this.$store.getters['ciudad/listCiudades'];
    },
    ciudadesSelect() {
      return this.ciudades.filter(
        (item) => item.id_departamento == this.user.departamento
      );
    },
    departamentos() {
      return this.$store.getters['departamento/listDepartamentos'];
    },
    checkBtn() {
      var isDisabled
      if (
        (this.user.nombre &&
          this.user.apellidos &&
          this.user.tipo_identificacion &&
          this.user.identificacion &&
          this.user.email &&
          this.user.direccion &&
          this.user.departamento &&
          this.user.ciudad &&
          this.user.telefono) != null &&
        (this.user.nombre &&
          this.user.apellidos &&
          this.user.tipo_identificacion &&
          this.user.identificacion &&
          this.user.email &&
          this.user.direccion &&
          this.user.departamento &&
          this.user.ciudad &&
          this.user.telefono) != '' &&
        this.passwordvalido === true
      ) {
        isDisabled = false
      } else {
        isDisabled = true
      }

      return isDisabled;
    },
    passwordMatchRule() {
      return (value) => {
        if (value === '') {
          this.passwordvalido = false
          return 'Por favor, confirma tu contraseña.';
        } else if (value !== this.user.password) {
          this.passwordvalido = false
          return 'Las contraseñas no coinciden.';
        } else if ((this.user.password && this.user.c_password) == null) {
          this.passwordvalido = false
          return 'Las contraseñas estan vacias';
        } else {
          this.passwordvalido = true
          return true;
        }
      };
    },
  },
};
</script>
